<div class="Modal">
  <div mat-dialog-actions class="container-modal-header">
    <div class="icon-warning">
      <span class="material-icons me-10">
        {{ data.icon }}
      </span>
      <p class="m-0 p-0">{{ data.textIcon }}</p>
    </div>
    <span class="material-icons icon-close" (click)="onNoClick()"> close </span>
  </div>

  <div class="ModalContent">
    <div class="TtlModal">
      <h1 mat-dialog-title>{{ data.title }}</h1>
      <p>{{ data.text }}</p>
    </div>
  </div>

  <hr class="m-0 p-0" />

  <div class="ModalContent">
    <div class="row">
      <div class="col d-flex justify-content-center align-items-center p-0">
        <button
          class="align-items-center Btn BtnPadrao"
          mat-button
          matDialogClose="true"
        >
          {{ data.textBtnOne }}
          <span class="material-icons align-middle iconBtn">
            {{ data.btnOneIcon }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <div class="ModalFooter" *ngIf="data.textExtra != ''">
    <p class="m-0 p-0">{{ data.textExtra }}</p>
  </div>

  <div
    class="box-phone"
    *ngIf="data.infoBoxIcon != '' || data.infoBoxNumber != ''"
  >
    <div class="Modal-Footer">
      <span class="material-icons align-middle me-10">
        {{ data.infoBoxIcon }}
      </span>
      <div class="box-text-phone text-center">
        <span>{{ data.infoBoxSpan }}</span>
        <p>
          {{ data.infoBoxNumber }}
        </p>
      </div>
    </div>
  </div>
</div>
